export default __webpack_public_path__ + "static/media/user.016401ba.svg";